import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {AdditionalEditComponent} from "./additional-edit.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider
            .when('/company/:companyId/additionals/add', {template: ''})
            .when('/company/:companyId/additionals/:id', {template: ''});
    }]);
/***/

const additionalRoutes: Routes = [
    {path: 'company/:companyId/additionals/add', component: AdditionalEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/additionals/add', component: AdditionalEditComponent},
    {path: 'company/:companyId/additionals/:id', component: AdditionalEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/additionals/:id', component: AdditionalEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(additionalRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AdditionalRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional-routing.module.ts